import * as yup from 'yup';
import { error } from '../text';

export const groupCreateSchema = yup.object().shape({
  name: yup.string().required(error.required).max(20, error.below20),
  description: yup.string().max(250, error.below250),
  memberUids: yup.array().of(yup.string().required()).default([]),
});

export const groupEditSchema = yup.object().shape({
  name: yup.string().required(error.required).max(20, error.below20),
  description: yup.string().max(250, error.below250),
  memberUids: yup.array().of(yup.string().required()).default([]),
});
